<template>
  <header class="header-wrap">
    <v-app-bar app color="white" elevate-on-scroll clipped-left>
      <router-link
        class="nav-link"
        :to="{ name: 'Welcome' }"
        aria-label="View collections"
      >
        <v-img
          alt="Client Logo"
          class="shrink ma-4"
          contain
          :src="logo.default"
          transition="scale-transition"
          width="140"
        />
      </router-link>
      <h2 v-if="hasClient !== false">{{ this.activeExpClient.name }}</h2>
      <v-spacer></v-spacer>

      <v-btn
        v-if="
          currentUser.roles.includes('client-manager') === true ||
          currentUser.permissions.create_sub_clients === true
        "
        :to="{ name: 'Dashboard' }"
        text
      >
        <v-icon left>mdi-view-dashboard</v-icon>
        <span class="d-none d-md-flex">Dashboard</span>
      </v-btn>

      <v-btn
        v-if="hasClient !== false"
        :to="{ name: 'CollectionsPage', params: { clientId: hasClient } }"
        text
      >
        <v-icon left>mdi-folder-multiple</v-icon>
        <span class="d-none d-md-flex">Collections</span>
      </v-btn>

      <v-btn
        :to="{ name: 'imagesPage', params: { clientId: hasClient } }"
        :disabled="hasClient === false"
        text
      >
        <v-icon left>mdi-magnify-plus</v-icon>
        <span class="d-none d-md-flex">Image search</span>
      </v-btn>

      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app right temporary clipped-top>
      <template #prepend>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>{{ currentUser.name }}</v-list-item-title>
            <v-list-item-subtitle>Logged In</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-account-arrow-right</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <a href="/profile">My account</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="currentUser.roles.includes('client-manager') === true || currentUser.num_clients > 1"
        >
          <v-list-item-icon>
            <v-icon>mdi-refresh</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <router-link
              class="nav-link"
              :to="{ name: 'Dashboard' }"
              aria-label="View collections"
            >
              <v-list-item-title>Switch Client</v-list-item-title>
            </router-link>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template #append>
        <div class="pa-2">
          <v-btn block color="primary" @click="logout()">
            <v-icon left>mdi-logout</v-icon>Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MainHeader",
  data: () => ({
    drawer: false,
    pixLogo: require("../assets/PIXL8---Final-sml.png"),
    logo: require("../assets/PIXL8---Final-sml.png"),
  }),
  computed: {
    hasClient() {
      if (this.activeExpClient) {
        if (this.activeExpClient.id) return this.activeExpClient.id;
      }
      return false;
    },
    ...mapGetters(["activeExpClient", "currentUser"]),
  },
  watch: {
    activeExpClient() {
      if (this.activeExpClient.logo_image !== null) {
        this.logo = this.activeExpClient.logo_image;
        return;
      }
      this.logo = this.pixLogo;
    },
  },
  methods: {
    logout() {
      this.axios({
        url: "logout",
        baseURL: "",
        method: "post",
      }).then(() => {
        location.reload();
      });
    },
  },
};
</script>
